import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M22 17H13V15H22V17ZM11 17H2V15H11V17ZM15 13H2V11H15V13ZM15 9H2V7H15V9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ListMinus"
);
